module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "GEQB-EBNative.html",
      "xml:lang": "en-US"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "cover-image",
    attrs: {
      "alt": "GEQuickbreads_cover-image.jpg",
      "height": "100%",
      "src": "images/GEQuickbreads_cover-im_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "GEQB-title-page.jpg",
      "height": "100%",
      "src": "images/GEQB-title-page_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "story"
  }, [_c('p', {
    staticClass: "copyright1"
  }), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Good Eating’s Quick Breads")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Chicago Tribune Staff")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright 2012 by the Chicago Tribune")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical, including copying, recording, or by any information storage and retrieval system, without express written permission from the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Chicago Tribune")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Tony W. Hunter, Publisher")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Vince Casanova, President")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Gerould W. Kern, Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("R. Bruce Dold, Editorial Page Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Bill Adee, Vice President/Digital")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Jane Hirt, Managing Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Joycelyn Winnecke, Associate Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Peter Kendall, Deputy Managing Editor")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Ebook edition 1.0 September 2012")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN-10 1-57284-432-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("ISBN-13 978-1-57284-432-2")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Agate Digital is an imprint of Agate Publishing. Agate books are available in bulk at discount prices. For more information visit "), _c('a', {
    attrs: {
      "href": "http://www.agatepublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("agatepublishing.com")]), _vm._v(".")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56416df5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GEQBEBNative.vue
// module id = 54
// module chunks = 0